<template>
  <div
    class="container"
    @mouseenter="hoveredOver = true"
    @mouseleave="hoveredOver = false"
  >
    <transition-group tag="div" :name="transitionName">
      <div :key="first" class="slide">
        <div v-if="!windowSizeLessThan850" class="slider-container">
          <Card :obj="data[first]" />
          <Card :obj="data[second]" />
        </div>

        <Card v-else :obj="data[first]" />
      </div>
    </transition-group>

    <div
      class="left-arrow button"
      @click="slide(-1, 'slide-prev')"
      @mouseenter="hoveredOver = true"
      @mouseleave="hoveredOver = false"
    >
      <img :src="leftArrow" alt="previous" />
    </div>
    <div
      class="right-arrow button"
      @click="slide(1, 'slide-next')"
      @mouseenter="hoveredOver = true"
      @mouseleave="hoveredOver = false"
    >
      <img :src="rightArrow" alt="next" />
    </div>
  </div>
</template>

<script>
import { generateFullPath } from '../utils/helpers'
import Card from './Card.vue'
import slide from '../mixins/slide'
import windowResize from '../mixins/windowResize'

export default {
  name: 'Slider',
  mixins: [slide, windowResize],

  props: {
    data: Array,
  },

  components: {
    Card,
  },

  data() {
    return {
      windowWidth: 0,
      first: 0,
      second: 0,
      transitionName: '',
      hoveredOver: false,
      intervalID: null,
    }
  },

  computed: {
    leftArrow() {
      const relativePath = '/themes/st2018/img/tile-arrow-left.png'
      return generateFullPath(relativePath)
    },

    rightArrow() {
      const relativePath = '/themes/st2018/img/tile-arrow-right.png'
      return generateFullPath(relativePath)
    },
  },

  created() {
    this.first = 0
    this.second = (this.first + 1) % this.data.length
  },

  mounted() {
    // this.intervalID = setInterval(() => {
    //   if (!this.hoveredOver) {
    //     this.slide(1, 'slide-next-slow')
    //   }
    // }, 5000)
  },

  beforeDestroy() {
    clearInterval(this.intervalID)
  },
}
</script>

<style scoped>
.container {
  height: 620px;
  width: 100%;
  position: relative;
  margin: 0 auto;
}

.slider-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-auto-rows: 1fr;
  column-gap: 20px;
}

.button {
  position: absolute;
  z-index: 10;
  cursor: pointer;
}

.left-arrow {
  top: 200px;
  left: -4%;
}

.right-arrow {
  top: 200px;
  left: auto;
  right: -4%;
}

.slide {
  width: 100%;
  position: absolute;
}

/* NEXT SLIDE SLOW */
.slide-next-slow-enter-active,
.slide-next-slow-leave-active {
  transition: all 2s ease-in-out;
}
.slide-next-slow-enter {
  opacity: 0;
}
.slide-next-slow-leave-to {
  opacity: 0;
}

/* NEXT SLIDE */
.slide-next-enter-active,
.slide-next-leave-active {
  transition: all 0.75s ease-in-out;
}
.slide-next-enter {
  opacity: 0;
}
.slide-next-leave-to {
  opacity: 0;
}

/* GO TO PREVIOUS SLIDE */
.slide-prev-enter-active,
.slide-prev-leave-active {
  transition: all 0.75s ease-in-out;
}
.slide-prev-enter {
  opacity: 0;
}
.slide-prev-leave-to {
  opacity: 0;
}

@media screen and (min-width: 1400px) {
  .container {
    width: 100%;
  }
}

@media screen and (max-width: 1400px) {
  .container {
    width: 80%;
  }
}

@media screen and (max-width: 990px) {
  .container {
    height: 620px;
  }

  .slider-container {
    grid-template-columns: 1fr;
  }

  .left-arrow {
    top: 190px;
    left: -6%;
  }

  .right-arrow {
    top: 190px;
    right: -6%;
  }
}

@media screen and (max-width: 770px) {
  .container {
    height: 650px;
  }
}

@media screen and (max-width: 430px) {
  .left-arrow {
    left: -10%;
  }

  .right-arrow {
    right: -10%;
  }
}
</style>
